<!-- Skeleton Loader estilo Instagram -->
@if (!post) {
  <div class="card-instagram" (click)="abrirModal()">
    <img src="./assets/img/default.png" alt="Último post de Instagram" class="post-img">
    
    <div class="overlay">
      <div class="stats">
        <span class="quicksand-medium "><i class="fa-solid fa-heart"></i> {{ post?.like_count || 0 }}</span>
        <span class="quicksand-medium"><i class="fa-solid fa-comment"></i> {{ post?.comments_count || 0 }}</span>
      </div>
    </div>
  </div>
}

<!-- Post de Instagram real -->
@if (post) {
  <div class="card-instagram zoomIn" (click)="abrirModal()">
    <img [src]="post.media_url" src="./assets/img/default.png" alt="Último post de Instagram" class="post-img">
    
    <div class="overlay">
      <div class="stats">
        <span class="quicksand-medium zoomIn"><i class="fa-solid fa-heart"></i> {{ post?.like_count || 0 }}</span>
        <span class="quicksand-medium zoomIn"><i class="fa-solid fa-comment"></i> {{ post?.comments_count || 0 }}</span>
      </div>
    </div>
  </div>
}

<!-- Modal -->
@if (mostrarModal) {
  <div class="modal-overlay" (click)="cerrarModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="btn-close" (click)="cerrarModal()">×</button>
      <iframe 
        [src]="iframeUrlSafe" 
        width="100%" 
        height="100%" 
        frameborder="0" 
        scrolling="no" 
        allowtransparency="true">
      </iframe>
    </div>
  </div>
}